import { c as _c } from "react/compiler-runtime";
/* eslint-disable no-underscore-dangle */
import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReCAPTCHA from 'react-google-recaptcha';
import loadable from '@loadable/component';
import validateEmail from 'commons/validateEmail';
import capitalizeFirstLetter from 'commons/capitalizeFirstLetter';
import BriteverifyClient from 'commons/britverify-client';
import isLocalhost from 'commons/isLocalhost';
import { INVALID_NAME_CHARACTERS_REGEX, RECAPTCHA_SITE_KEY } from 'commons/constants';
import WarrantyForm from 'components/consumer/WarrantyForm';
import CtaButton from 'components/essentials/Cta/CtaButton';
import FrameContainer from 'components/consumer/FrameContainer';
import LabeledTextarea from 'components/consumer/LabeledTextarea';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import FlatButtonFilters from 'components/consumer/FlatButtonFilters';
import Radio from 'components/essentials/Radio';
import IconAskAQuestion from 'components/icons/IconAskAQuestion';
import { colorBrandLightest } from 'styles/layout/colors';
import FrameContainerHeader from 'components/consumer/FrameContainerHeader';
import useUserData from 'data-hooks/useUserData';
import useIsBrowserLayout from 'hooks/useIsBrowserLayout';
import questionsAndAnswers from './questionsAndAnswers.json';
import CtaLink from '../../essentials/Cta/CtaLink';
const AnimateHeight = loadable(() => import('react-animate-height'));
const normalizeName = value => capitalizeFirstLetter((value || '').trim().toLowerCase());
const normalizeEmail = value => (value || '').trim().toLowerCase();
const ContactEnquiryFormUI = t0 => {
  const $ = _c(90);
  const {
    error,
    loading,
    onSubmit
  } = t0;
  const {
    email: userEmail,
    firstName
  } = useUserData();
  const nameInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const isBrowser = useIsBrowserLayout();
  const [name, setName] = useState(undefined);
  const [email, setEmail] = useState(undefined);
  let t1;
  if ($[0] !== firstName || $[1] !== isBrowser) {
    t1 = isBrowser ? normalizeName(firstName) : "";
    $[0] = firstName;
    $[1] = isBrowser;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const prefilledName = t1;
  let t2;
  if ($[3] !== isBrowser || $[4] !== userEmail) {
    t2 = isBrowser ? normalizeEmail(userEmail) : "";
    $[3] = isBrowser;
    $[4] = userEmail;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const prefilledEmail = t2;
  const nameToShow = name !== undefined ? name : prefilledName;
  const emailToShow = email !== undefined ? email : prefilledEmail;
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState("");
  const [selectedTag, setSelectedTag] = useState("");
  const [message, setMessage] = useState("");
  const [reCaptchaValue, setReCaptchaValue] = useState("");
  const [isNameValid, setIsNameValid] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isSelectedTopicValid, setIsSelectedTopicValid] = useState(true);
  const [isMessageValid, setIsMessageValid] = useState(true);
  const [isReCaptchaValid, setIsReCaptchaValid] = useState(true);
  const _isNameValid = !!nameToShow;
  let t3;
  if ($[6] !== emailToShow) {
    t3 = !!emailToShow && validateEmail(emailToShow);
    $[6] = emailToShow;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const _isEmailValid = t3;
  const _isSelectedTopicValid = !!selectedTopic;
  const _isMessageValid = !!message;
  const _isSelectedQuestionValid = !!selectedQuestion;
  let t4;
  if ($[8] !== reCaptchaValue) {
    t4 = !isLocalhost() ? !!reCaptchaValue : true;
    $[8] = reCaptchaValue;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const _isReCaptchaValid = t4;
  const isOptionSelected = _isSelectedTopicValid && _isSelectedQuestionValid;
  let t5;
  let t6;
  if ($[10] !== email || $[11] !== isBrowser || $[12] !== name || $[13] !== prefilledEmail || $[14] !== prefilledName) {
    t5 = () => {
      if (!isBrowser) {
        return;
      }
      if (name === undefined && !prefilledName && nameInputRef.current?.value) {
        setName(normalizeName(nameInputRef.current.value));
      }
      if (email === undefined && !prefilledEmail && emailInputRef.current?.value) {
        setEmail(normalizeEmail(emailInputRef.current.value));
      }
    };
    t6 = [email, isBrowser, name, prefilledEmail, prefilledName];
    $[10] = email;
    $[11] = isBrowser;
    $[12] = name;
    $[13] = prefilledEmail;
    $[14] = prefilledName;
    $[15] = t5;
    $[16] = t6;
  } else {
    t5 = $[15];
    t6 = $[16];
  }
  useLayoutEffect(t5, t6);
  const isSubmitValid = _isNameValid && _isEmailValid && _isSelectedTopicValid && _isSelectedQuestionValid && _isMessageValid && _isReCaptchaValid;
  let t7;
  if ($[17] !== _isEmailValid || $[18] !== _isMessageValid || $[19] !== _isNameValid || $[20] !== _isReCaptchaValid || $[21] !== _isSelectedTopicValid || $[22] !== emailToShow || $[23] !== isSubmitValid || $[24] !== message || $[25] !== nameToShow || $[26] !== onSubmit || $[27] !== reCaptchaValue || $[28] !== selectedQuestion || $[29] !== selectedTag || $[30] !== selectedTopic) {
    t7 = () => {
      if (isSubmitValid) {
        onSubmit({
          name: nameToShow,
          email: emailToShow.trim(),
          subject: selectedTopic,
          question: selectedQuestion || "Other",
          tag: selectedTag,
          message,
          subscribe: false,
          phone: "",
          reCaptchaValue
        });
      }
      setIsNameValid(_isNameValid);
      setIsEmailValid(_isEmailValid);
      setIsSelectedTopicValid(_isSelectedTopicValid);
      setIsMessageValid(_isMessageValid);
      setIsReCaptchaValid(_isReCaptchaValid);
    };
    $[17] = _isEmailValid;
    $[18] = _isMessageValid;
    $[19] = _isNameValid;
    $[20] = _isReCaptchaValid;
    $[21] = _isSelectedTopicValid;
    $[22] = emailToShow;
    $[23] = isSubmitValid;
    $[24] = message;
    $[25] = nameToShow;
    $[26] = onSubmit;
    $[27] = reCaptchaValue;
    $[28] = selectedQuestion;
    $[29] = selectedTag;
    $[30] = selectedTopic;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  const validateAndSubmit = t7;
  let t8;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FrameContainerHeader icon={<IconAskAQuestion color={colorBrandLightest} />} title="Ask us a question" subtitle={"Contact one of our experts and we\u2019ll get back to you as soon as possible."} />;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t10;
  let t9;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e => {
      setIsNameValid(true);
      setName(e.target.value);
    };
    t10 = evt => {
      if (INVALID_NAME_CHARACTERS_REGEX.test(evt.target.value)) {
        setIsNameValid(false);
      } else {
        setIsNameValid(true);
      }
    };
    $[33] = t10;
    $[34] = t9;
  } else {
    t10 = $[33];
    t9 = $[34];
  }
  const t11 = !isNameValid ? "Please enter valid characters only." : undefined;
  let t12;
  if ($[35] !== nameToShow || $[36] !== t11) {
    t12 = <LabeledTextInput ref={nameInputRef} label="Your name" autoComplete="name" value={nameToShow} onChange={t9} onBlur={t10} errorMessage={t11} />;
    $[35] = nameToShow;
    $[36] = t11;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = e_0 => {
      setIsEmailValid(true);
      setEmail(e_0.target.value);
    };
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== emailToShow) {
    t14 = async evt_0 => {
      const updatedEmail = evt_0.target.value.trim();
      if (emailToShow !== updatedEmail) {
        setEmail(updatedEmail);
      }
      const validate = await BriteverifyClient.emailLookup(updatedEmail);
      if (!validate?.valid && validate?.message) {
        setIsEmailValid(false);
      } else {
        setIsEmailValid(true);
      }
    };
    $[39] = emailToShow;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  const t15 = !isEmailValid ? "Please enter a valid email address." : undefined;
  let t16;
  if ($[41] !== emailToShow || $[42] !== t14 || $[43] !== t15) {
    t16 = <LabeledTextInput ref={emailInputRef} label="Email address" type="email" autoComplete="email" value={emailToShow} onChange={t13} onBlur={t14} errorMessage={t15} />;
    $[41] = emailToShow;
    $[42] = t14;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="text-lg font-bold mb-3">What can we help you with today?</div>;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = questionsAndAnswers.map(_temp);
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== selectedTopic) {
    t19 = topicId => {
      setIsSelectedTopicValid(true);
      if (topicId !== selectedTopic) {
        setSelectedTag("");
        setSelectedQuestion("");
        setSelectedTopic(topicId);
      }
    };
    $[47] = selectedTopic;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== selectedTopic || $[50] !== t19) {
    t20 = <FlatButtonFilters items={t18} isSelectedButtonFilled={true} selectedItem={selectedTopic} setSelectedItem={t19} />;
    $[49] = selectedTopic;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  let t21;
  if ($[52] !== isSelectedTopicValid) {
    t21 = !isSelectedTopicValid && <div className="text-red text-xs font-bold mt-[3px]">Please select an option.</div>;
    $[52] = isSelectedTopicValid;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== t20 || $[55] !== t21) {
    t22 = <div className="mt-8 mx-0 mb-10">{t17}{t20}{t21}</div>;
    $[54] = t20;
    $[55] = t21;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== selectedQuestion || $[58] !== selectedTopic || $[59] !== userEmail) {
    t23 = !!selectedTopic && !!questionsAndAnswers.find(topic_1 => topic_1.topicId === selectedTopic) && <div className="mt-8 mx-0 mb-10 [border-top:1px_solid_#f1f1f1] pt-8"><div className="text-lg font-bold mb-3">We can help! What's your question?</div><div>{questionsAndAnswers.find(topic_0 => topic_0.topicId === selectedTopic).questions.map((t24, questionIndex) => {
          const {
            question,
            answer,
            tag,
            warrantyFooter,
            warrantyForm: t25
          } = t24;
          const warrantyForm = t25 === undefined ? false : t25;
          return <><Radio key={`${selectedTopic}-${questionIndex}`} onChange={() => {
              setSelectedTag(tag);
              setSelectedQuestion(question);
            }} checked={selectedQuestion === question}><span className={classNames("text-base", {
                "text-base font-bold": selectedQuestion === question
              })}>{question}</span></Radio>{(answer.length > 0 || warrantyForm || warrantyFooter) && <AnimateHeight duration={500} height={selectedQuestion === question && question !== "Other" ? "auto" : 0}><div className="bg-gray-light8 rounded mt-2 mx-0 mb-4 p-8 [&_p]:text-base [&_p_a]:ml-1 [&_p+p]:mt-5">{answer.map(_temp2)}{warrantyForm && <WarrantyForm email={userEmail || null} redirectToStep2={true} variant="ContactEnquiryForm" />}{warrantyFooter && <p className="ContactEnquiryFormUI__question-warrantyFooter">If you’d like to submit a warranty request, please see our<CtaLink to="/issues/" color="brand" target="_blank" hasArrow={false}>warranty form.</CtaLink></p>}</div></AnimateHeight>}</>;
        })}</div></div>;
    $[57] = selectedQuestion;
    $[58] = selectedTopic;
    $[59] = userEmail;
    $[60] = t23;
  } else {
    t23 = $[60];
  }
  let t24;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = e_1 => {
      setIsMessageValid(true);
      setMessage(e_1.target.value);
    };
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  const t25 = !isMessageValid ? "Please tell us more about what we can help you with." : undefined;
  let t26;
  if ($[62] !== message || $[63] !== t25) {
    t26 = <LabeledTextarea label="Your Message. Please include order number where applicable." value={message} onChange={t24} errorMessage={t25} />;
    $[62] = message;
    $[63] = t25;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  let t27;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <ReCAPTCHA name="reCaptchaValue" sitekey={RECAPTCHA_SITE_KEY} onChange={value => {
      setReCaptchaValue(value);
      if (value) {
        setIsReCaptchaValid(true);
      }
    }} />;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  let t28;
  if ($[66] !== isReCaptchaValid) {
    t28 = !isReCaptchaValid && <div className="text-red text-xs font-bold mt-[3px]">Please confirm that you are not a robot</div>;
    $[66] = isReCaptchaValid;
    $[67] = t28;
  } else {
    t28 = $[67];
  }
  let t29;
  if ($[68] !== t28) {
    t29 = <div className="mb-8">{t27}{t28}</div>;
    $[68] = t28;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  const t30 = !isSubmitValid || loading;
  let t31;
  if ($[70] !== loading || $[71] !== t30 || $[72] !== validateAndSubmit) {
    t31 = <CtaButton block={true} spacing="xs" disabled={t30} onClick={validateAndSubmit} isLoading={loading}>Send your question</CtaButton>;
    $[70] = loading;
    $[71] = t30;
    $[72] = validateAndSubmit;
    $[73] = t31;
  } else {
    t31 = $[73];
  }
  let t32;
  if ($[74] !== error) {
    t32 = error && <div className="text-red text-xs font-bold mt-[3px]">{error}</div>;
    $[74] = error;
    $[75] = t32;
  } else {
    t32 = $[75];
  }
  let t33;
  if ($[76] !== isOptionSelected) {
    t33 = !isOptionSelected && <div className="text-xs font-bold mt-[3px] text-gray text-center">Please select an option above</div>;
    $[76] = isOptionSelected;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== t31 || $[79] !== t32 || $[80] !== t33) {
    t34 = <div className="ContactEnquiryFormUI__submit-section">{t31}{t32}{t33}</div>;
    $[78] = t31;
    $[79] = t32;
    $[80] = t33;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  let t35;
  if ($[82] !== t12 || $[83] !== t16 || $[84] !== t22 || $[85] !== t23 || $[86] !== t26 || $[87] !== t29 || $[88] !== t34) {
    t35 = <FrameContainer wide={true} className="max-[767px]:!pb-8 md:!rounded-none">{t8}{t12}{t16}{t22}{t23}{t26}{t29}{t34}</FrameContainer>;
    $[82] = t12;
    $[83] = t16;
    $[84] = t22;
    $[85] = t23;
    $[86] = t26;
    $[87] = t29;
    $[88] = t34;
    $[89] = t35;
  } else {
    t35 = $[89];
  }
  return t35;
};
ContactEnquiryFormUI.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};
export default ContactEnquiryFormUI;
function _temp(topic) {
  return {
    label: topic.topicLabel,
    id: topic.topicId
  };
}
function _temp2(answerParagraph) {
  return <p className="[&_a]:text-brand [&_a]:underline" dangerouslySetInnerHTML={{
    __html: answerParagraph
  }} />;
}